import * as React from 'react';
import type { MotionStyle } from 'framer-motion';
import { cn } from '@/utils/cn';
import { ModalShell } from './ModalShell';
import closeIcon from '@/assets/images/svg/close_icon.svg';

export interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  children: React.ReactNode;
  className?: string;
  hideCloseButton?: boolean;
  style?: React.CSSProperties;
}

/**
 * Centered modal with the standard 4px brand border and a scroll-capped body.
 * Composes `ModalShell` for the backdrop + animation; only owns the close
 * button + content padding.
 */
export const Modal: React.FC<ModalProps> = ({
  isOpen,
  onClose,
  children,
  className,
  hideCloseButton = false,
  style,
}) => (
  <ModalShell
    isOpen={isOpen}
    onClose={onClose}
    position='center'
    bodyClassName={cn(
      'flex w-full max-w-[334px] flex-col overflow-hidden',
      'max-h-[90vh] rounded-20 border-4 border-brand-800',
      'bg-white shadow-2xl',
      className
    )}
    {...(style ? { bodyStyle: style as MotionStyle } : {})}
  >
    {!hideCloseButton && (
      <button
        onClick={onClose}
        className='absolute right-4 top-4 z-10 transition-opacity hover:opacity-70'
        aria-label='Close modal'
      >
        <img src={closeIcon} alt='Close' className='size-6' />
      </button>
    )}

    <div className='global-scrollbar overflow-y-auto px-8 py-10 md:px-[38px] md:py-10'>
      {children}
    </div>
  </ModalShell>
);
